export default (obj, keyMaps) => {
  const newObj = {};
  keyMaps.forEach(key => {
    newObj[key.new] = obj[key.old];
  });
  return { ...newObj, ...obj };
};
